import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './Calendari.css';
import API_URL from '../config'; 
require('moment/locale/ca');

const localizer = momentLocalizer(moment);

const Calendari = () => {
  const [events, setEvents] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date()); // Estat per la data
  const [view, setView] = useState('month'); // Estat per la vista

const minTime = new Date();
    minTime.setHours(9, 0, 0); 

const maxTime = new Date();
    maxTime.setHours(21, 0, 0); 

  useEffect(() => {
    fetch(`${API_URL}/api/gestio/sessions/totes/`, {
      headers: { 'Authorization': `Token ${sessionStorage.getItem('token')}` }
    })
    .then(res => res.json())
    .then(data => {
      const transformats = data
        .filter(s => s.data_realitzacio) 
        .map(s => ({
          title: `Sessió: ${s.client_nom}`,
          start: new Date(s.data_realitzacio),
          end: new Date(new Date(s.data_realitzacio).getTime() + 60 * 60 * 1000), // Durada de 1 hora de les sessions
          allDay: false
      }));
      setEvents(transformats);
    });
  }, []);

  return (
    <div className="contenidor-calendari">
      <Calendar
        localizer={localizer}
        events={events}
        messages={{
            next: "Següent",
            previous: "Anterior",
            today: "Avui",
            month: "Mes",
            week: "Setmana",
            day: "Dia",
            agenda: "Agenda",
            date: "Data",
            time: "Hora",
            event: "Esdeveniment",
            showMore: (count) => `+${count} més`,
            noEventsInRange: "No hi ha sessions en aquest període.",
        }}
        startAccessor="start"
        popup={true}
        endAccessor="end"
        date={currentDate}
        view={view}
        min={minTime}
        max={maxTime}
        onNavigate={(date) => setCurrentDate(date)}
        onView={(view) => setView(view)}
      />
    </div>
  );
};

export default Calendari;